import React from 'react'

export default function Projects() {
    return (
        <div className="container-article " >
            <h1 className="text-center" style={{ paddingTop: "30%" }}>
                Projects
            </h1>
        </div>
    )
}
